import { useState, useEffect } from 'react';
import { db } from '../../../firebase/config';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';

export function useProjects() {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getDocs(query(collection(db, 'projects'), orderBy('projectNumber', 'asc')))
      .then(snap => {
        setProjects(snap.docs.map(d => ({
          id: d.id,
          projectNumber: d.data().projectNumber || '',
          name: d.data().name || '',
        })));
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return { projects, loading };
}
